package com.eladfinish.bible.contest.navigation

import androidx.navigation.NavOptionsBuilder

// Navigation commands that can be triggered from Fragments / Activity / shortcuts
sealed interface NavigationCommand {
    data class Navigate(
        val destination: NavigationDestination,
        val navOptions: (NavOptionsBuilder.() -> Unit)? = null,
    ) : NavigationCommand
}
